import $ from 'jquery'

// Tippy/Popper attaches an rAF update loop to its reference element. If we yank that element out
// of the DOM (jQuery replaceWith) without destroying the instance first, Popper keeps trying to
// measure a detached node — and the whole tab freezes (no clicks, DevTools dies). Stimulus
// disconnect eventually calls tippy.destroy(), but MutationObserver is async; destroy here is
// synchronous so the loop stops before replaceWith returns.
function destroyTippyIn(root) {
  if (!root) return
  const nodes = [root, ...root.querySelectorAll('*')]
  for (const node of nodes) {
    node._tippy?.destroy?.()
  }
}

export function replaceWithPreserves(element, html) {
  const replacements = element.find('[data-preserve-during-replace]')
  const newElement = $(html)

  let restoreFocusOnElement =
    document.activeElement &&
    element[0]?.contains(document.activeElement) &&
    document.activeElement

  element.each(function () {
    destroyTippyIn(this)
  })

  element.replaceWith(newElement)
  if (replacements.length > 0) {
    replacements.each((index, el) => {
      if (!el.id) {
        throw new Error(
          'You must provide an id on elements that have data-preserve-during-replace'
        )
      }
      newElement.find(`#${el.id}`).replaceWith(el)
    })
  }

  // If the element that was focused before was inside the element to be replaced, and is still present (was preserved), focus it again
  if (restoreFocusOnElement && newElement[0]?.contains(restoreFocusOnElement)) {
    restoreFocusOnElement.focus()
    restoreFocusOnElement.setSelectionRange?.(-1, -1)
  }

  $(newElement).changed?.()
  return newElement
}
